<div class="entry-exit-wrapper">
    <table *ngIf="parkingEvents" [dataSource]="parkingEvents" mat-table matSort>
        <!-- Datetime column -->
        <ng-container matColumnDef="eventDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tid och datum </th>
            <td mat-cell *matCellDef="let row">
                <div class="flex-wrapper">
                    <span>{{formatDate(row.eventDate)}}</span> <strong> {{formatTime(row.eventDate)}}</strong>
                </div>
            </td>
        </ng-container>

        <!-- User -->
        <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Användare </th>
            <td mat-cell *matCellDef="let row"> {{row.eventBy ? (row.eventBy.name || row.eventBy.username) : 'SKIDATA'}}
            </td>
        </ng-container>

        <!-- Parking device -->
        <ng-container matColumnDef="parkingDevice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bom </th>
            <td mat-cell *matCellDef="let row">
                <div *ngIf="row.parkingDevice" class="flex-wrapper">
                    <span> {{row.parkingDevice.name}}</span>
                    <mat-icon *ngIf="row.parkingDevice.bookingEventType === 'PARKING_EXIT'" title="Lämnat P">
                        exit_to_app
                    </mat-icon>
                </div>
                <span *ngIf="!row.parkingDevice" class="no-device">Ingen</span>
            </td>
        </ng-container>

        <!-- Parking event -->
        <ng-container matColumnDef="parkingEventType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Händelse </th>
            <td mat-cell *matCellDef="let row">
                <div class="flex-wrapper">
                    <span> {{row.bookingEventType}}</span>
                </div>
            </td>
        </ng-container>

        <!-- Scan type -->
        <ng-container matColumnDef="scanType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Registrerats med </th>
            <td mat-cell *matCellDef="let row"> {{row.scanType}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>